import "./AjoutCours.css";
import React from "react";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import InputGroup from 'react-bootstrap/InputGroup';



function template() {
  return (
        


    <div className="ajout-cours  ">
      <h5>Ajouter un nouveau cours</h5>
    <p>Il suffit de remplir le formulaire et de créer vos cours.</p>
    <hr></hr>
      <div className="cont-ajout-cours">
      <Form>
      <Form.Group className="mb-3 py-3" controlId="formBasicEmail">
        <Form.Label>Titre du cours</Form.Label>
        <Form.Control className="py-3" type="text" placeholder="Titre du cours" />
         <Form.Text id="passwordHelpBlock" muted>
         Rédigez un titre de cours de 60 caractères.
      </Form.Text>
     
      </Form.Group>

      <Form.Select className="py-3" aria-label="Default select example">
      <option>Selectinner un categorie</option>
      <option value="1">html css</option>
      <option value="2">java scrpit</option>
      <option value="3">React</option>
      
    </Form.Select>
    <Form.Text id="passwordHelpBlock" muted>
    Aidez les gens à trouver vos cours en choisissant des catégories qui représentent votre cours.
      </Form.Text>

    <span></span>
    
  <p className="mt-4">Description du cours</p>
    <FloatingLabel className="-4 " controlId="floatingTextarea2" >
      
        <Form.Control
          as="textarea"
          placeholder="Leave a comment here"
          style={{ height: '80px' }}
        />
      </FloatingLabel>
      <Form.Text id="passwordHelpBlock" muted> Un bref résumé de vos cours.
          </Form.Text>
     

          <Form.Group controlId="formFile" className="mt-3">
        <Form.Label>Image de couverture du cours</Form.Label>
        <Form.Control type="file" />
      </Form.Group>
      {/* <Button variant="primary" type="submit">
        Submit
      </Button> */}
  
    <Form.Text id="passwordHelpBlock" muted> Téléchargez votre image de cours ici. Il doit répondre à nos normes de
     qualité d’image de cours pour être accepté. Directives importantes:
      750x440 pixels; .jpg, .jpeg,. gif ou .png.. </Form.Text>
          
          <Form.Label className="mt-4" htmlFor="basic-url">Entrez une URL de vidéo valide</Form.Label>
      <InputGroup className="mb-3">
        <InputGroup.Text id="basic-addon3">
          https://example.com/users/
        </InputGroup.Text>
        <Form.Control id="basic-url" aria-describedby="basic-addon3" />
      </InputGroup>
      
      <div class="d-flex justify-content-between">
      
      <Button variant="danger">Annuler</Button>
      <Button variant="outline-success">Envoyer</Button>
      </div>
      </Form>
    </div>
    </div>
  );
};

export default template;
